import { StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';


export const CASH_FACTS: { [factName: string]: FactMappingInterface } = {
	cashPercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.portfolioBreakdowns',
				[
					{ propertyToCompare: 'name', comparedValue: 'assetClass', desiredValueExpression: 'sectors' }
				]
			)
		], sectors => {
			return (sectors.find(child => child.name === 'Cash')?.contribution || 0) * 100;
		})
	}
};
